import V2DepositWithdrawalHistoryTable from 'src/components/HistoryTables/V2DepositWithdrawalHistoryTable';
import PortfolioHistoryBalancesTableControls from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryBalancesTable/PortfolioHistoryBalancesTableControls';

export default function PortfolioHistoryBalancesTable() {
	return (
		<div>
			<PortfolioHistoryBalancesTableControls />
			<V2DepositWithdrawalHistoryTable />
		</div>
	);
}
